export const environment = {
  production: true,
  automationUserName: 'admin@automation',
  domainURL: 'https://neuron.affineanalytics.ai:5555'
};
